import { render, staticRenderFns } from "./ProjectUIUX.vue?vue&type=template&id=55631926&"
import script from "./ProjectUIUX.vue?vue&type=script&lang=js&"
export * from "./ProjectUIUX.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUIUX.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports